import anime from 'animejs'

export function tweenSlideOut () {
    // this.$refs.overlayLoader.style.transform = 'scaleX(0)'

    const tween = anime({
        targets: this.$refs.overlayLoader,
        scaleX: [0, 1],
        opacity: [0, 1],
        duration: 500,
        easing: 'easeInOutQuint'
    })

    return tween.finished
}

export function tweenSlideIn () {
    const timeline = anime.timeline()

    this.$refs.overlayLoader.style.transformOrigin = '0 50%'

    timeline.add({
        targets: this.$refs.overlayLoader,
        scaleX: [1, 0],
        duration: 500,
        easing: 'easeInOutQuint'
    })

    timeline.finished.then(() => {
        this.$refs.overlayLoader.style.transformOrigin = null
        this.$refs.overlayLoader.style.transform = null
        this.$refs.overlayLoader.style.opacity = null
    })

    return timeline.finished
}


// WEBPACK FOOTER //
// ./app/theme/components/full-slider/full-slider-tweens.js